<template>
  <div class="layout">
    <div class="header" :class="headType === 1 ? 'home-header header' : headType === 2 ? 'header active' : 'header actives'">
      <div class="header-container">
        <h1 class="logo">
          <img v-if="headType === 1 && sysInfo.logo_white" :src="sysInfo.logo_white" @click="$router.push({ name: 'home' })" alt="" />
          <Img v-if="headType === 1 && !sysInfo.logo_white" src="/logo.png" @click.native="$router.push({ name: 'home' })" alt="" />
          <img v-if="headType !== 1 && sysInfo.logo_black" :src="sysInfo.logo_black" @click="$router.push({ name: 'home' })" alt="" />
          <Img v-if="headType !== 1 && !sysInfo.logo_black" src="/logo-h.png" @click.native="$router.push({ name: 'home' })" alt="" />
        </h1>
        <nav>
          <ul v-if="$store.state.userinfo && $store.state.userinfo.kind == 2">
            <li
              :class="{
                active: $route.query.my
                  ? $route.meta.belong === item.routerName && item.key === 'task_my'
                  : $route.meta.belong === item.routerName && item.key !== 'task_my'
              }"
              v-for="(item, index) in menuList2"
              @click="
                $router.push({
                  name: item.routerName,
                  query: item.query || undefined
                })
              "
              :key="index"
            >
              <!-- <Img :src="item.icon" alt="" /> -->
              <span>{{ item.title }}<span class="lines"></span></span>
            </li>
          </ul>
          <ul v-else>
            <li
              :class="{
                active: $route.query.my
                  ? $route.meta.belong === item.routerName && item.key === 'task_my'
                  : $route.meta.belong === item.routerName && item.key !== 'task_my'
              }"
              v-for="(item, index) in menuList"
              @click="
                $router.push({
                  name: item.routerName,
                  query: item.query || undefined
                })
              "
              :key="index"
            >
              <!-- <Img :src="item.icon" alt="" /> -->
              <span>{{ item.title }}<span class="lines"></span></span>
            </li>
          </ul>
        </nav>
        <div class="ownaction">
          <Poptip placement="bottom-end" width="320" v-if="XToken">
            <!-- <Avatar class="avatar" src="/avatar.png" icon="ios-person" size="large" /> -->
            <Img v-if="headType === 1" src="/avatar.png" class="avatar" alt="" />
            <Img v-else src="/avatar-l.png" class="avatar" alt="" />
            <div class="user-content" slot="content">
              <div class="user-content-phone">
                {{ userinfo.name }}
                <a href="javascript:;" @click="handleActivate">{{ userLimits.state === 1 ? '未激活' : userLimits.state === 2 ? '已激活' : '已过期' }}</a>
              </div>
              <p class="logout" @click="handleLogout">退出</p>
            </div>
          </Poptip>
          <router-link :to="{ name: 'login' }" :class="$route.name === 'home' ? 'login-btn' : 'login-btn color468 '" v-else>请登录</router-link>
        </div>
      </div>
    </div>
    <div class="home-content" v-if="$route.name === 'home'">
      <router-view></router-view>
    </div>
    <div class="content" v-else>
      <!-- <div class="bread-crumbs" v-if="!hideBread">
        <Breadcrumb>
          <BreadcrumbItem :to="$route.name === 'home' ? '' : '/'">首页</BreadcrumbItem>
          <BreadcrumbItem v-for="(item, index) in breadList" :key="index" :to="item.routerName === $route.name ? '' : item.path">{{
            item.title
          }}</BreadcrumbItem>
        </Breadcrumb>
      </div> -->
      <div class="content-main">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
// import { Poptip, Breadcrumb, BreadcrumbItem, Modal } from 'view-design'
import { Poptip, Modal } from 'view-design'
import { mapState } from 'vuex'
export default {
  components: {
    Poptip
    // Breadcrumb,
    // BreadcrumbItem
  },
  data() {
    return {
      menuList: [
        {
          icon: '/index_icon.png',
          title: '首页',
          routerName: 'home',
          key: 'home'
        },
        {
          icon: '/nav-icon1.png',
          title: '环境库',
          routerName: 'environment',
          key: 'environment'
        },
        {
          icon: '/nav-icon2.png',
          title: '任务库',
          routerName: 'task',
          key: 'task'
        },
        {
          icon: '/nav-icon2.png',
          title: '实战营',
          routerName: 'combat_camp',
          key: 'combat_camp'
        }
        // ,
        // {
        //   icon: '/nav-icon3.png',
        //   title: '工具库',
        //   routerName: ''
        // },
        // {
        //   icon: '/nav-icon4.png',
        //   title: '任务编辑器',
        //   routerName: ''
        // }
      ],
      menuList2: [
        {
          icon: '/index_icon.png',
          title: '首页',
          routerName: 'home',
          key: 'home'
        },
        {
          icon: '/nav-icon1.png',
          title: '环境库',
          routerName: 'environment',
          key: 'environment'
        },
        {
          icon: '/nav-icon2.png',
          title: '任务库',
          routerName: 'task',
          key: 'task'
        },
        {
          icon: '/nav-icon2.png',
          title: '我的任务',
          routerName: 'task',
          key: 'task_my',
          query: { my: 1 }
        },
        {
          icon: '/nav-icon2.png',
          title: '实战营',
          routerName: 'combat_camp',
          key: 'combat_camp'
        }
      ],
      sysInfo: this.$store.state.sysInfo
    }
  },
  computed: {
    ...mapState(['userinfo', 'breadList', 'userLimits']),
    // token
    XToken() {
      return localStorage.getItem('X-Token')
    },
    // 是否隐藏面包屑
    hideBread() {
      return this.$route.meta.hideBread
    },
    headType() {
      return this.$route.name === 'home' ? 1 : this.$route.name === 'environment' ? 2 : this.$route.name === 'task' ? 2 : 3
    }
  },
  created() {
    this.$store.dispatch('getSysInfo')
    // 判断是否需要获取用户信息
    if (localStorage.getItem('X-Token')) {
      this.$store.dispatch('getUserinfo')
    }
  },

  methods: {
    // 弹出激活弹窗
    handleActivate() {
      if (this.userLimits.state !== 2) {
        this.$store.commit('SET_ACTIVATEVISIBLE', {
          filed: 'visible1',
          status: true
        })
      }
    },
    // 登出确认框
    handleLogout() {
      Modal.confirm({
        title: '提示',
        content: '确定退出当前实战平台？',
        loading: true,
        onOk: () => {
          this.logout()
        }
      })
    },
    // 登出
    async logout() {
      const params = {
        uriCode: 'API010'
      }
      await this.$fetch(params)
      Modal.remove()
      localStorage.clear()
      sessionStorage.clear()
      this.$store.dispatch('resetState')
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  height: 100vh;
}

.header.active {
  background-color: #f0f8fa !important;
  color: #333 !important;
  box-shadow: 0px 1px 0px 0px rgba(44, 45, 51, 0.1);
}

.header.actives {
  background-color: #fff !important;
  color: #333 !important;
  box-shadow: 0px 1px 0px 0px rgba(44, 45, 51, 0.1);
}

.header {
  width: 100%;
  box-sizing: border-box;
  height: 60px;
  background: #484848;
  color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 6;

  .logo {
    img {
      width: 245px;
      height: 42px;
      margin-top: 9px;
    }
  }

  .header-container {
    padding: 0 40px;
    min-width: 1440px;
    display: flex;
    max-width: 1440px;
    margin: auto;
    position: relative;
  }

  &.home-header {
    background-color: #143662;
  }

  h1 {
    width: 428px;

    // height: 20px;
    // padding-left: 36px;
    img {
      height: 100%;
      position: relative;
      top: 4px;
      cursor: pointer;
    }
  }
}

nav {
  margin-left: 128px;

  ul {
    display: flex;
    height: 100%;

    li {
      display: flex;
      align-items: center;
      height: 100%;
      margin-right: 68px;
      font-size: 16px;
      cursor: pointer;

      img {
        margin-right: 10px;
      }

      span {
        display: block;
        height: 100%;
        line-height: 60px;
        font-size: 16px;

        .lines {
          display: none;
        }
      }

      &.active span {
        color: #468fef;

        .lines {
          display: block;
          height: 4px;
          width: 60%;
          margin: auto;
          background-color: #468fef !important;
          margin-top: -4px;
        }
      }
    }
  }
}

.home-content {
  height: 100%;
}

.content {
  // height: 100%;
  max-width: 1440px;
  margin: auto;
  padding: 60px 0px 0px;
  height: 100vh;
  overflow-y: auto;

  &-main {
    // height: calc(100% - 60px);
    position: relative;
    // overflow-y: auto;
  }

  .bread-crumbs {
    font-size: 16px;
    margin-bottom: 10px;

    a {
      font-weight: bold;
      margin-right: 4px;
    }
  }
}

.ownaction {
  display: flex;
  align-items: center;
  position: absolute;
  justify-content: flex-end;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  width: 120px;
  height: 40px;

  // a {
  //   color: #fff;
  //   margin-right: 10px;
  //   display: block;
  //   width: 110px;
  //   text-align: right;
  // }
  .user-content {
    color: #414e5e;
    padding: 13px 5px 0;
    box-sizing: border-box;

    &-phone {
      display: flex;
      margin-bottom: 15px;

      a {
        margin-left: 20px;
        color: #015fff;
      }
    }

    .logout {
      height: 40px;
      line-height: 40px;
      border-top: 1px solid #e8eaec;
      cursor: pointer;
    }
  }

  // cursor: pointer;
}

nav ul:first-child {
  img {
    width: 18px !important;
    height: 18px !important;
  }
}

.color468 {
  background: #468fef !important;
}

.login-btn {
  display: block;
  width: 80px !important;
  height: 34px;
  // background: linear-gradient(225deg, #92d5c9 0%, #59ab99 100%);
  background: #468fef !important;
  border-radius: 2px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 20px;
  text-align: center;
  line-height: 32px;
  cursor: pointer;
  margin-right: 40px;
}

.avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  margin-right: 40px;
}
.item-menus {
  flex-direction: column !important;
  padding: 0px !important;
  span {
    line-height: 36px;
    margin: 0 !important;
    padding: 0 !important;
    text-align: center;
    color: #666666 !important;
    font-size: 14px;
  }
  span:hover {
    background-color: #b3d4fc;
    color: #fff !important;
  }
}
</style>
